import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import SiteEffects from "@/components/SiteEffects";
import PreorderBanner from "@/components/PreorderBanner";
import Home from "@/pages/Home";
import ProductList from "@/pages/ProductList";
import ProductDetail from "@/pages/ProductDetail";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AdminDashboard from "@/pages/AdminDashboard";
import Returns from "@/pages/Returns";
import MeshSeries from "@/pages/MeshSeries";
import MeshSeriesSuccess from "@/pages/MeshSeriesSuccess";
import Wheels from "@/pages/Wheels";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import "@/App.css";

function AppShell() {
  const location = useLocation();
  // Detect session_id in URL fragment (must be synchronous)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const hideChrome = location.pathname === "/login";
  return (
    <>
      <SiteEffects count={90} />
      {!hideChrome && <PreorderBanner />}
      {!hideChrome && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/wheels" element={<Wheels />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/apparel" element={<ProductList category="apparel" title="Apparel" label="Garments & Headwear" />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/returns" element={<Returns />} />
        <Route path="/mesh-series" element={<MeshSeries />} />
        <Route path="/mesh-series/success" element={<MeshSeriesSuccess />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <CartDrawer />
      {!hideChrome && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppShell />
            <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0F0F0F", color: "#fff", border: "1px solid rgba(255,255,255,0.1)" } }} />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
